import { Me, adminAuthApi } from "api";
import { useContext, useEffect } from "react";
import { AuthActionTypes, AuthContext } from "store/auth/AuthContext";

export const useAdminMe = () => {
  const accessToken = localStorage.getItem("api_token");
  const { dispatch, state } = useContext(AuthContext);
  const fetchMe = async () => {
    try {
      const resData = !accessToken ? ({} as Me) : (await adminAuthApi.fetchMe()).data;
      dispatch({
        type: AuthActionTypes.SetUser,
        payload: resData,
      });
    } catch (error) {
      // TODO logout??
      dispatch({
        type: AuthActionTypes.SetUser,
        payload: {} as Me,
      });
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    }
  };
  useEffect(() => {
    fetchMe();
  }, []);

  return state;
};
